import React, { useState } from 'react';
import { Confirm, Input } from 'semantic-ui-react';
import './CriticalConfirmModal.scss';

function CriticalConfirmModal({
  confirmProps,
  confirmButton,
  confirmableText,
  content,
  onConfirm = () => {},
}) {
  const [confirmText, setConfirmText] = useState('');

  const canConfirm = !confirmText
    .trim()
    .localeCompare(confirmableText.trim(), 'es', {
      sensitivity: 'base',
    });

  const handleConfirm = () => {
    if (canConfirm) {
      setConfirmText('');
      onConfirm();
    }
  };

  return (
    <Confirm
      {...confirmProps}
      confirmButton={{
        children: (Button, buttonProps) => (
          <Button {...buttonProps} disabled={!canConfirm}>
            {confirmButton}
          </Button>
        ),
      }}
      onCancel={() => {
        setConfirmText('');
        confirmProps?.onCancel?.();
      }}
      onConfirm={handleConfirm}
      content={
        <div className="content confirm-modal">
          <div>{content}</div>
          <div>
            Por seguridad, escribe{' '}
            <i className="confirm-modal__confirmable-text">{confirmableText}</i>{' '}
            en el siguiente campo:
          </div>
          <div>
            <Input
              className="confirm-modal__input"
              autoFocus
              value={confirmText}
              onChange={(event, data) => {
                setConfirmText(data.value);
              }}
            />
          </div>
        </div>
      }
    />
  );
}

export default CriticalConfirmModal;
